"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowStyled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
require("../types");
exports.TableRowStyled = styled_components_1.default.tr `
  ${helpers_1.getTableRowHeight};

  ${({ selected, hasSelection, theme }) => hasSelection &&
    styled_components_1.css `
      background-color: ${selected && theme.colorHighlightDark};

      &:hover {
        background-color: ${selected ? theme.colorHighlightDark : theme.colorHighlightLight};
      }

      &:active {
        background-color: ${theme.colorHighlightDark};
      }
    `}
`;
exports.TableRowStyled.displayName = 'TableRowStyled';
//# sourceMappingURL=TableRowStyled.js.map